import React from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import closeIcon from "../../assets/images/icons/close.svg"

function RaisedQueriesViewModal({ steps, open, setOpen }) {
  return (
    <>
      <Modal
        isOpen={open}
        toggle={() => {
          setOpen((prev) => !prev)
        }}
        returnFocusAfterClose={true}
        centered
        className="custom-size"
      >
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          Raised Query
        </ModalHeader>
        <ModalBody>
          <div className="">
            <div className="d-flex flex-column raise-query-modal-wrapper">
              {steps.map((item, index) => (
                <div
                  className="d-flex align-items-center justify-content-between gap-3 raise-query-modal"
                  key={`selectedSteps_${index}`}
                >
                  <div>
                    <span
                      style={{
                        fontWeight: "500",
                        marginRight: "5px",
                        fontSize: "15px",
                      }}
                    >
                      {item.label}
                    </span>
                    <div style={{ color: "#a5a5a5", whiteSpace: "pre-wrap" }}>
                      {item.message}
                    </div>
                  </div>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setSelectedSteps((prev) =>
                        prev.filter((_, i) => i !== index)
                      )
                    }
                  ></span>
                </div>
              ))}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default RaisedQueriesViewModal
